/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { CancelExchangeForbiddenStatusDto } from '../../src/model';
// @ts-ignore
import type { CancelExchangeInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { CancelExchangeNotFoundDto } from '../../src/model';
// @ts-ignore
import type { CancelExchangeOkDto } from '../../src/model';
// @ts-ignore
import type { GetExchangeAmountLastWeekInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetExchangeAmountLastWeekOkDto } from '../../src/model';
// @ts-ignore
import type { GetExchangesInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetExchangesOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeCodeBadRequestDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeConflictDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeCreatedDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeForbiddenAmountDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeForbiddenNameDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeForbiddenNotYetForeignerDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeForbiddenRrnRequiredDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeNotFoundBankAccountUuidDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostExchangeUnauthorizedDto } from '../../src/model';
/**
 * ExchangeApi - axios parameter creator
 * @export
 */
export const ExchangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 환급 취소
         * @param {string} exchangeUuid 환급 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerCancelExchange: async (exchangeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeUuid' is not null or undefined
            assertParamExists('exchangeControllerCancelExchange', 'exchangeUuid', exchangeUuid)
            const localVarPath = `/exchange/{exchangeUuid}`
                .replace(`{${"exchangeUuid"}}`, encodeURIComponent(String(exchangeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 지난 주에 얻은 환급 금액 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerGetExchangeAmountLastWeek: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exchange/last-week`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 환급 내역 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerGetExchanges: async (page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 환급 신청
         * @param {PostExchangeReqBodyDto} postExchangeReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerPostExchange: async (postExchangeReqBodyDto: PostExchangeReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postExchangeReqBodyDto' is not null or undefined
            assertParamExists('exchangeControllerPostExchange', 'postExchangeReqBodyDto', postExchangeReqBodyDto)
            const localVarPath = `/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postExchangeReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExchangeApi - functional programming interface
 * @export
 */
export const ExchangeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExchangeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 환급 취소
         * @param {string} exchangeUuid 환급 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeControllerCancelExchange(exchangeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelExchangeOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeControllerCancelExchange(exchangeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeApi.exchangeControllerCancelExchange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 지난 주에 얻은 환급 금액 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeControllerGetExchangeAmountLastWeek(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExchangeAmountLastWeekOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeControllerGetExchangeAmountLastWeek(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeApi.exchangeControllerGetExchangeAmountLastWeek']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 환급 내역 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeControllerGetExchanges(page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExchangesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeControllerGetExchanges(page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeApi.exchangeControllerGetExchanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 환급 신청
         * @param {PostExchangeReqBodyDto} postExchangeReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeControllerPostExchange(postExchangeReqBodyDto: PostExchangeReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostExchangeCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeControllerPostExchange(postExchangeReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeApi.exchangeControllerPostExchange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExchangeApi - factory interface
 * @export
 */
export const ExchangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExchangeApiFp(configuration)
    return {
        /**
         * 
         * @summary 환급 취소
         * @param {ExchangeApiExchangeControllerCancelExchangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerCancelExchange(requestParameters: ExchangeApiExchangeControllerCancelExchangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<CancelExchangeOkDto> {
            return localVarFp.exchangeControllerCancelExchange(requestParameters.exchangeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 지난 주에 얻은 환급 금액 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerGetExchangeAmountLastWeek(options?: RawAxiosRequestConfig): AxiosPromise<GetExchangeAmountLastWeekOkDto> {
            return localVarFp.exchangeControllerGetExchangeAmountLastWeek(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 환급 내역 조회
         * @param {ExchangeApiExchangeControllerGetExchangesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerGetExchanges(requestParameters: ExchangeApiExchangeControllerGetExchangesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetExchangesOkDto> {
            return localVarFp.exchangeControllerGetExchanges(requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 환급 신청
         * @param {ExchangeApiExchangeControllerPostExchangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerPostExchange(requestParameters: ExchangeApiExchangeControllerPostExchangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostExchangeCreatedDto> {
            return localVarFp.exchangeControllerPostExchange(requestParameters.postExchangeReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for exchangeControllerCancelExchange operation in ExchangeApi.
 * @export
 * @interface ExchangeApiExchangeControllerCancelExchangeRequest
 */
export interface ExchangeApiExchangeControllerCancelExchangeRequest {
    /**
     * 환급 uuid
     * @type {string}
     * @memberof ExchangeApiExchangeControllerCancelExchange
     */
    readonly exchangeUuid: string
}

/**
 * Request parameters for exchangeControllerGetExchanges operation in ExchangeApi.
 * @export
 * @interface ExchangeApiExchangeControllerGetExchangesRequest
 */
export interface ExchangeApiExchangeControllerGetExchangesRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof ExchangeApiExchangeControllerGetExchanges
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof ExchangeApiExchangeControllerGetExchanges
     */
    readonly limit?: number
}

/**
 * Request parameters for exchangeControllerPostExchange operation in ExchangeApi.
 * @export
 * @interface ExchangeApiExchangeControllerPostExchangeRequest
 */
export interface ExchangeApiExchangeControllerPostExchangeRequest {
    /**
     * 
     * @type {PostExchangeReqBodyDto}
     * @memberof ExchangeApiExchangeControllerPostExchange
     */
    readonly postExchangeReqBodyDto: PostExchangeReqBodyDto
}

/**
 * ExchangeApi - object-oriented interface
 * @export
 * @class ExchangeApi
 * @extends {BaseAPI}
 */
export class ExchangeApi extends BaseAPI {
    /**
     * 
     * @summary 환급 취소
     * @param {ExchangeApiExchangeControllerCancelExchangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExchangeApi
     */
    public exchangeControllerCancelExchange(requestParameters: ExchangeApiExchangeControllerCancelExchangeRequest, options?: RawAxiosRequestConfig) {
        return ExchangeApiFp(this.configuration).exchangeControllerCancelExchange(requestParameters.exchangeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 지난 주에 얻은 환급 금액 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExchangeApi
     */
    public exchangeControllerGetExchangeAmountLastWeek(options?: RawAxiosRequestConfig) {
        return ExchangeApiFp(this.configuration).exchangeControllerGetExchangeAmountLastWeek(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 환급 내역 조회
     * @param {ExchangeApiExchangeControllerGetExchangesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExchangeApi
     */
    public exchangeControllerGetExchanges(requestParameters: ExchangeApiExchangeControllerGetExchangesRequest = {}, options?: RawAxiosRequestConfig) {
        return ExchangeApiFp(this.configuration).exchangeControllerGetExchanges(requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 환급 신청
     * @param {ExchangeApiExchangeControllerPostExchangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExchangeApi
     */
    public exchangeControllerPostExchange(requestParameters: ExchangeApiExchangeControllerPostExchangeRequest, options?: RawAxiosRequestConfig) {
        return ExchangeApiFp(this.configuration).exchangeControllerPostExchange(requestParameters.postExchangeReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

